import axios from "axios";
import { EventTypeEnum } from "../../../Models/Event/EventTypeEnum";
import { IEventType } from "../../../Models/EventTypes/IEventType";
import { IResult } from "../../../Models/Result/IResult";
import { formatUrl, handleError } from "../ApiHelpers";
import { IEventTypeApi } from "./IEventTypeApi";

export class EventTypeApi implements IEventTypeApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getEventTypes(onlyForWeb: boolean, type?: EventTypeEnum): Promise<IResult<IEventType[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventType/GetEventType?onlyForWeb=${onlyForWeb}${type != undefined ? '&type=' + type : ''}`);
            const response = await axios.get(url);
            return response.data as IResult<IEventType[]>;
        }
        catch (error) {
            return handleError(error, "getEventTypes");
        }
    }

    async createEventType(eventType: IEventType): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventType/CreateEventType`);
            const response = await axios.post(url, eventType);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "createAgeGroup");
        }
    }

    async updateEventType(eventType: IEventType): Promise<IResult<string>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventType/UpdateEventType/${eventType.id}`);
            const response = await axios.put(url, eventType);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "updateAgeGroup");
        }
    }


    async deleteEventType(id: number): Promise<IResult<string>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/EventType/DeleteEventType/${id}`);
            const response = await axios.delete(url);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "deleteAgeGroup");
        }
    }

    async eventTypeUploadImage(eventTypeId: number, name: string, file: File, callback?: (progress: number, fileName: string) => void): Promise<IResult<string>> {
        var data = new FormData();
        data.append('id', eventTypeId.toString());
        data.append('name', name);
        data.append('file', file);
        var config = {
            onUploadProgress: function (progess: any) {
                var percentCompleted = Math.round((progess.loaded * 100) / progess.total);
                callback && callback(percentCompleted, file.name);
            }
        };
        try {
            const url = formatUrl(this.backendUrl, `/api/EventType/UploadImage`);
            const response = await axios.post(url, data, config);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "uploadImage");
        }
    }
   

}
